module.exports = __webpack_public_path__ + "media/fonts/typicons-d45316f67adb2dd7191ee4917b8ac46b.ttf";